import { InjectionToken } from '@angular/core';

/**
 * Provided as `true` by a host whose result lists answer a selection it holds itself (the Atlas panel's Sources view), with no
 * item open in the 3rd panel. The sections then count as active, so their type and sort buttons are enabled. The Knowledge Panel
 * does not provide it: its sections stay disabled until an item is open, as before.
 */
export const KP_SELECTION_DRIVEN = new InjectionToken<boolean>('KP_SELECTION_DRIVEN');
